import { messages } from 'languages'
import keyMirror from 'pkeymirror'
import { getCurrentLanguage, getUUID, intl, setHtmlLangAndDir, setThemeVariables } from 'utils'
import callAPI from 'utils/callAPI'
import { encrypt } from 'utils/rsa'
import UAParser from 'ua-parser-js'
import _ from 'lodash'
import { message } from 'antd'
import queryString from 'query-string'

// ------------------------------------
// Constants
// ------------------------------------
export const SITE_CONFIG = keyMirror({
  LANGUAGE_CHANGE: null,
  GET_SALT_REQUEST: null,
  GET_SALT_SUCCESS: null,
  GET_IDENTITY_REQUEST: null,
  GET_IDENTITY_SUCCESS: null,
  TOGGLE_FETCH_STATUS: null,
  REFRESH_CAPTCHA_REQUEST: null,
  REFRESH_CAPTCHA_SUCCESS: null,
  QUERY_PROTOCOL_REQUEST: null,
  QUERY_PROTOCOL_SUCCESS: null,
  HANDLE_REQUEST: null,
  HANDLE_SUCCESS: null,
  GET_THEME_VARIABLES_REQUEST: null,
  GET_THEME_VARIABLES_SUCCESS: null,
  GET_COUNTRIES_REQUEST: null,
  GET_COUNTRIES_SUCCESS: null,
  GET_CAPTCHA_SUCCESS:null,
  GET_CAPTCHA_REQUEST:null,
  SEND_SMS_SUCCESS:null,
  SEND_SMS_REQUEST:null
}, 'SITE_CONFIG')

// ------------------------------------
// Actions
// ------------------------------------
export function languageChange(lang = 'en') {
  const language = lang.split(/[-_]/)[0].toLowerCase()
  const dir = setHtmlLangAndDir(language)
  localStorage.lang = language
  return (dispatch) => {
    dispatch({
      type    : SITE_CONFIG.LANGUAGE_CHANGE,
      payload : {
        language,
        dir
      }
    })
  }
}

export function getAppSalt(saltKey) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          saltKey,
        },
        endpoint: 'common/getAppSalt',
        requestAction: SITE_CONFIG.GET_SALT_REQUEST,
        successAction: SITE_CONFIG.GET_SALT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getIdentity(data) {
  return (dispatch) => {
    const saltKey = getUUID()
    return dispatch(toggleLoading(true))
      .then((res) => dispatch(getAppSalt(saltKey)))
      .then((res) => {
        const { salt } = res.payload
        if (!salt) {
          throw new Error(' ')
        }

        // 如果有邮箱，对邮箱加密
        if (data.serviceParams.memberPhone) {
          const memberPhone = data.serviceParams.memberPhone
          console.log(memberPhone, 'memberPhone')
          data.serviceParams.memberPhone = encrypt(memberPhone, salt)
          // TODO: 兼容风控系统,memberPhone和mobile同时存在
          data.serviceParams.mobile = data.serviceParams.memberPhone
        }

        return dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            header: {
              'Salt-Key': saltKey,
            },
            body: data,
            endpoint: 'grc/v1/unauth/get-identity',
            requestAction: SITE_CONFIG.GET_IDENTITY_REQUEST,
            successAction: SITE_CONFIG.GET_IDENTITY_SUCCESS,
            success: function(result) {
              // TODO: 获取到结果如果需要图像验证码，则展示图像验证码，否则发送OTP
              const captchaImg = _.chain(result)
                .get('identifyHint.preIdentifyMethods')
                .find({ method: 'CAPTCHA' })
                .get('data.captchaImg')
                .value()
              console.log(captchaImg)
              if (captchaImg) {
                dispatch({
                  type: SITE_CONFIG.REFRESH_CAPTCHA_SUCCESS,
                  payload: {
                    captchaImg,
                  },
                })
              }
            },
          })
        )
      })
      .then((res) => {
        const identifyTicket = _.get(res.payload, 'identifyHint.identifyTicket')
        const needCaptcha = _.chain(res)
          .get('payload.identifyHint.preIdentifyMethods')
          .find({ method: 'CAPTCHA' })
          .value()
        if (!identifyTicket) {
          throw new Error(' ')
        }
        if (needCaptcha) {
          throw new Error(' ')
        }

        // 后期如新增验证方式，通过eventType来路由对于的函数
        return dispatch(sendOTP())
      })
      .catch((res) => {
        dispatch(toggleLoading(false))
      })
  }
}

export function refreshCaptcha() {
  return (dispatch, getState) => {
    const identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          identifyTicket,
        },
        endpoint: 'risk-identify/v1/unauth/refresh-captcha',
        requestAction: SITE_CONFIG.REFRESH_CAPTCHA_REQUEST,
        successAction: SITE_CONFIG.REFRESH_CAPTCHA_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function removeCaptcha() {
  return (dispatch) => {
    return dispatch({
      type: SITE_CONFIG.REFRESH_CAPTCHA_SUCCESS,
      payload: {
        captchaImg: undefined,
      },
    })
  }
}

export function verifyCaptcha(data) {
  return (dispatch, getState) => {
    data.identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'risk-identify/v1/unauth/verify-captcha',
        requestAction: SITE_CONFIG.HANDLE_REQUEST,
        successAction: SITE_CONFIG.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function sendEmailOTP(data = {}) {
  return (dispatch, getState) => {
    data.identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'risk-identify/v1/unauth/send-email-otp',
        requestAction: SITE_CONFIG.HANDLE_REQUEST,
        successAction: SITE_CONFIG.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function sendOTP(data = {}) {
  return (dispatch, getState) => {
    data.identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    data.otpType = 'mobile'
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'risk-identify/v1/unauth/send-identity-otp',
        requestAction: SITE_CONFIG.HANDLE_REQUEST,
        successAction: SITE_CONFIG.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function verifyOTP(data, form) {
  return (dispatch, getState) => {
    data.identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    data.otpTicket = _.get(getState().siteConfig, 'otpTicket')
    if (!data.otpTicket) {
      message.error(intl().formatMessage(messages['app.error.pleaseSendOTPFirst']))
      return
    }
    data.otpType = 'mobile'
    data.requestId = Date.now()
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'risk-identify/v1/unauth/verify-identity-otp',
        requestAction: SITE_CONFIG.HANDLE_REQUEST,
        successAction: SITE_CONFIG.HANDLE_SUCCESS,
        success: function(result) {},
        error: function(result, msg) {
          message.error(msg)
          switch (result.head.code) {
            // 91205  otp验证不通过，不需要重新发送otp
            // 91206  otp验证不通过，重新发送otp，不需要验证码
            // 91207  otp验证不通过，重新发送otp，需要验证码
            case '91206':
              dispatch(removeCaptcha())
              form.resetFields(['captcha'])
              break
            case '91207':
              dispatch(refreshCaptcha())
              form.resetFields(['captcha', 'otp'])
              break
            default:
              break
          }
        }
      })
    )
  }
}

export function verifyEmailOTP(data, form) {
  return (dispatch, getState) => {
    data.identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'risk-identify/v1/unauth/verify-email-otp',
        requestAction: SITE_CONFIG.HANDLE_REQUEST,
        successAction: SITE_CONFIG.HANDLE_SUCCESS,
        success: function(result) {},
        error: function(result, msg) {
          message.error(msg)
          switch (result.head.code) {
            // 91205  otp验证不通过，不需要重新发送otp
            // 91206  otp验证不通过，重新发送otp，不需要验证码
            // 91207  otp验证不通过，重新发送otp，需要验证码
            case '91206':
              dispatch(removeCaptcha())
              form.resetFields(['captcha'])
              break
            case '91207':
              dispatch(refreshCaptcha())
              form.resetFields(['captcha', 'otp'])
              break
            default:
              break
          }
        }
      })
    )
  }
}

export function login(data, form) {
  return (dispatch, getState) => {
    const saltKey = getUUID()
    const identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    return dispatch(toggleLoading(true, 'LoginLoading'))
      .then((res) => dispatch(verifyOTP({ otpCode: data.otp }, form)))
      .then((res) => {
        if (res.payload.result !== 'pass') {
          res.payload.message && message.error(`${res.payload.message}`)
          throw new Error(res.payload.message)
        }
        return dispatch(getAppSalt(saltKey))
      })
      .then((res) => {
        const { salt } = res.payload
        if (!salt) {
          throw new Error(' ')
        }

        const orderToken = getState().siteConfig.orderToken

        return dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            header: {
              'Salt-Key': saltKey,
            },
            body: {
              orderToken,
              identifyTicket,
              mobileNo: encrypt(data.memberPhone, salt),
            },
            endpoint: 'cashierii/login/v1/unauth/verify',
            requestAction: SITE_CONFIG.HANDLE_REQUEST,
            successAction: SITE_CONFIG.HANDLE_SUCCESS,
            success: function(result) {
              if (result.loginToken) {
                sessionStorage[orderToken] = result.loginToken
                sessionStorage[`${orderToken}-loginType`] = 'memberPhone'
                sessionStorage[`${orderToken}-memberPhone`] = data.memberPhone

                dispatch({
                  type: 'SITE_CONFIG_HANDLE_SUCCESS',
                  payload: {
                    loginToken: sessionStorage[orderToken],
                    loginType: 'memberPhone',
                    memberPhone: data.memberPhone,
                  },
                })
              }
            },
          })
        )
      })
      .then((res) => {
        if (!res.payload.loginToken) {
          throw new Error(' ')
        }

        return res
      })
      .catch((res) => {
        dispatch(toggleLoading(false, 'LoginLoading'))
      })
  }
}

export function loginToSaveCard(data, form) {
  return (dispatch, getState) => {
    const saltKey = getUUID()
    const identifyTicket = _.get(
      getState().siteConfig,
      'identifyHint.identifyTicket'
    )
    return dispatch(toggleLoading(true, 'LoginLoading'))
      .then((res) => dispatch(verifyOTP({ otpCode: data.otp }, form)))
      .then((res) => {
        if (res.payload.result !== 'pass') {
          res.payload.message && message.error(`${res.payload.message}`)
          throw new Error(res.payload.message)
        }
        return dispatch(getAppSalt(saltKey))
      })
      .then((res) => {
        const { salt } = res.payload
        if (!salt) {
          throw new Error(' ')
        }

        const orderToken = getState().siteConfig.orderToken
        const paymentOrderNo = queryString.parse(window.location.search).paymentOrderNo
        return dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            header: {
              'Salt-Key': saltKey,
            },
            body: {
              orderToken,
              paymentOrderNo,
              identifyTicket,
              mobileNo: encrypt(data.memberPhone, salt),
            },
            endpoint: 'cashierii/pay/v1/unauth/save-card',
            requestAction: SITE_CONFIG.HANDLE_REQUEST,
            successAction: SITE_CONFIG.HANDLE_SUCCESS,
            success: function(result) {
              sessionStorage[orderToken] = result.loginToken
              sessionStorage[`${orderToken}-loginType`] = 'memberPhone'
              dispatch({
                type: 'SITE_CONFIG_HANDLE_SUCCESS',
                payload: {
                  loginToken: sessionStorage[orderToken],
                  loginType: 'memberPhone',
                },
              })
              // TODO: 未测试流程
              if (getState().siteConfig.isMobile) {
                dispatch(setCardResultVisible(true))
                return
              }
              message.success(intl().formatMessage(messages['app.siteConfig.Cardsavedsuccessfully']), 2)
            },
          })
        )
      })
      .then((res) => {
        if (res.payload.request !== 'success') {
          throw new Error(' ')
        }
      })
      .catch((res) => {
        dispatch(toggleLoading(false, 'LoginLoading'))
      })
  }
}

export function loginToNPSS(data, form) {
  return (dispatch, getState) => {
    const saltKey = getUUID()
    const identifyTicket = _.get(getState().siteConfig, 'identifyHint.identifyTicket')
    return dispatch(toggleLoading(true, 'LoginLoading'))
      .then((res) => dispatch(verifyOTP({ otpCode: data.otp }, form)))
      .then((res) => {
        if (res.payload.result !== 'pass') {
          res.payload.message && message.error(`${res.payload.message}`)
          throw new Error(res.payload.message)
        }
        return dispatch(getAppSalt(saltKey))
      })
      .then((res) => {
        const { salt } = res.payload
        if (!salt) {
          throw new Error(' ')
        }

        return dispatch(
          callAPI({
            dispatch: dispatch,
            method: 'POST',
            header: {
              'Salt-Key': saltKey,
            },
            body: {
              eventType:'PAYPAGE_LOGIN',
              ticket: identifyTicket,
              mobileNo: encrypt(data.memberPhone, salt),
              state:data.state,
              nonce:data.nonce
            },
            endpoint: 'npss/customer/v1/unauth/sca-validate-ticket',
            requestAction: SITE_CONFIG.HANDLE_REQUEST,
            successAction: SITE_CONFIG.HANDLE_SUCCESS,
            success: function(result) {
            },
          })
        )
      })
      .then((res) => {
        if (!res.payload.redirectUrl) {
          throw new Error(' ')
        }

        return res
      })
      .catch((res) => {
        dispatch(toggleLoading(false, 'LoginLoading'))
      })
  }
}

export function deleteCard(data) {
  return (dispatch, getState) => {
    const loginToken = getState().siteConfig.loginToken
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          ...data,
          loginToken,
        },
        endpoint: 'cashierii/order/v1/unauth/delete-pay-method',
        requestAction: SITE_CONFIG.HANDLE_REQUEST,
        successAction: SITE_CONFIG.HANDLE_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryProtocol(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cashierii/common/v1/unauth/query-protocol',
        requestAction: SITE_CONFIG.QUERY_PROTOCOL_REQUEST,
        successAction: SITE_CONFIG.QUERY_PROTOCOL_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function getCountries() {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          scene:'LOGIN'
        },
        endpoint: 'cmsii/country/queryAreaCode',
        requestAction: SITE_CONFIG.GET_COUNTRIES_REQUEST,
        successAction: SITE_CONFIG.GET_COUNTRIES_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function toggleLoading(isLoading, uniqKey) {
  return (dispatch) => {
    const payload = {}
    payload[uniqKey || 'loading'] = isLoading
    dispatch({
      type: SITE_CONFIG.TOGGLE_FETCH_STATUS,
      payload: payload,
    })
    return Promise.resolve()
  }
}

export function getThemeVariables() { // 获取主题变量
  return (dispatch, getState) => {
    const { orderToken, pageCustomize } = getState().siteConfig
    if (pageCustomize) {
      setThemeVariables(pageCustomize)
      return
    }
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: { orderToken },
        endpoint: 'cashierii/common/v1/unauth/query-page-customize',
        requestAction: SITE_CONFIG.GET_THEME_VARIABLES_REQUEST,
        successAction: SITE_CONFIG.GET_THEME_VARIABLES_SUCCESS,
        success: function(result) {
          if (result.pageCustomize) {
            setThemeVariables(result.pageCustomize)
            sessionStorage[`${orderToken}-pageCustomize`] = JSON.stringify(result.pageCustomize)
          }
        },
        error: function(result) {}
      })
    )
  }
}

export function setCardResultVisible(visible) {
  return {
    type:SITE_CONFIG.HANDLE_SUCCESS,
    payload:{
      cardSaveResultVisible:visible
    }
  }
}

//  ================message pay start================

export function sendSms(data, callback) {
  return (dispatch) => {
    const saltKey = getUUID()
    return dispatch(
      getAppSalt(saltKey)
    ).then((res) => {
      // 调用接口前先获取盐做手机号加密
      const { salt } = res.payload
      if (!salt) {
        throw new Error(' ')
      }
      const { phoneNo, ...restData } = data
      restData.phoneNo = encrypt(phoneNo, salt)
      return dispatch(
        callAPI({
          dispatch: dispatch,
          method: 'POST',
          header: {
            'Salt-Key': saltKey,
          },
          body: restData,
          endpoint: 'personal/sendPaySms',
          requestAction: SITE_CONFIG.SEND_SMS_REQUEST,
          successAction: SITE_CONFIG.SEND_SMS_SUCCESS,
          success: (result) => {
            // dispatch(getCaptcha())
            typeof callback === 'function' && callback()
          },
        })
      ).catch(() => {
        dispatch(getCaptcha())
      })
    })
  }
}

export function getCaptcha() {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'personal/getCaptcha',
        requestAction: SITE_CONFIG.GET_CAPTCHA_REQUEST,
        successAction: SITE_CONFIG.GET_CAPTCHA_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ================message pay end================

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
const ACTION_HANDLERS = {
  [SITE_CONFIG.LANGUAGE_CHANGE]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_IDENTITY_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_IDENTITY_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.TOGGLE_FETCH_STATUS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.REFRESH_CAPTCHA_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.REFRESH_CAPTCHA_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_PROTOCOL_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.QUERY_PROTOCOL_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.HANDLE_REQUEST]: (state, action) => state,
  [SITE_CONFIG.HANDLE_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_THEME_VARIABLES_REQUEST]: (state, action) => state,
  [SITE_CONFIG.GET_THEME_VARIABLES_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_COUNTRIES_REQUEST]: (state, action) => state,
  [SITE_CONFIG.GET_COUNTRIES_SUCCESS]: (state, action) =>
    Object.assign({}, state, { allowedCountries:action.payload }),
  [SITE_CONFIG.GET_CAPTCHA_REQUEST]: (state, action) => state,
  [SITE_CONFIG.GET_CAPTCHA_SUCCESS]: (state, action) =>
    Object.assign({}, state, { captcha: action.payload }),
  [SITE_CONFIG.SEND_SMS_REQUEST]: (state, action) => state,
  [SITE_CONFIG.SEND_SMS_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [SITE_CONFIG.GET_SALT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer and set default language
// ------------------------------------
const language = getCurrentLanguage()
const dir = setHtmlLangAndDir(language)

const params = queryString.parse(window.location.search)
const orderToken = params.ft || params.orderToken

const initialState = {
  isMobile: new UAParser().getDevice().type === 'mobile',
  language,
  dir,
  // messages,
  orderToken,
  loginToken: sessionStorage[orderToken],
  loginType: sessionStorage[`${orderToken}-loginType`],
  memberPhone: sessionStorage[`${orderToken}-memberPhone`],
  pageCustomize: sessionStorage[`${orderToken}-pageCustomize`] && JSON.parse(sessionStorage[`${orderToken}-pageCustomize`]),
  allowedCountries:{ list:[] },
  cardSaveResultVisible:false
}

function reducer(state = initialState, action = {}) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default {
  id: 'siteConfig',
  reducerMap: {
    siteConfig: reducer,
  },
  // Actions to fire when this module is added/removed
  // initialActions: [],
  // finalActions: []
}
